import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from '@fluentui/react-components';
import {
  Delete20Regular,
  Edit20Regular,
  MoreHorizontal20Regular,
} from '@fluentui/react-icons';

/**
 * Composant label pour le nœud Holidays
 */
const HolidaysNodeLabel = ({ callFlowData, handleEditNode, handleDeleteNode }) => {
  const { t } = useTranslation();
  const holidaysData = callFlowData?.deskOpen?.holidays || {};
  const hasWeekendDays = holidaysData.weekendDays && holidaysData.weekendDays.length > 0;
  const hasHolidayDays = holidaysData.daysOff && holidaysData.daysOff.length > 0;

  return (
    <div className="node-holidays">
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <button
            className="node-menu-btn"
            onClick={(e) => e.stopPropagation()}
            title="Options"
          >
            <MoreHorizontal20Regular />
          </button>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleEditNode('holidays');
              }}
            >
              {t('EDIT')}
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteNode('holidays');
              }}
            >
              {t('DELETE')}
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
      <div className="node-title">{t('HOLIDAYS')}</div>
      <div className="node-separator"></div>
      <div className="node-info">
        {hasWeekendDays && (
          <div className="node-info-item">
            {holidaysData.weekendDays.length} {t('WEEKENDS', { count: holidaysData.weekendDays.length })}
          </div>
        )}
        {hasHolidayDays && (
          <div className="node-info-item">
            🎉 {holidaysData.daysOff.length} {t('HOLIDAY_DAYS', { count: holidaysData.daysOff.length })}
          </div>
        )}
      </div>
    </div>
  );
};

export default HolidaysNodeLabel;
